import {spinAnim} from "@cdx/ds/components/DSIcon/DSIcon.css";
import dsStyles from "@cdx/ds/css/index.css";
import {style} from "@vanilla-extract/css";

export const spinnerStyles = {
  g: style({
    animation: `${spinAnim} 2s infinite linear`,
    transformOrigin: "50% 50%",
  }),
  cover: style([{zIndex: -1}, dsStyles.bg.coverOverlay]),
};
